import { Modal } from 'bootstrap'

const myModal = new Modal(document.getElementById('policy'))